import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query'
import { guestTokenApi, type TokenResponse } from '../api/authApi'
import LogTool from '../../../logger/logTools'

const log = new LogTool({ context: 'AuthMutations', enable: true, logLevel: 'warn' })

export interface GuestTokenRequest {
  guestId: string
  password: string
}

/**
 * Hook to obtain guest token using guest_id and password
 */
export function useGuestToken(): UseMutationResult<TokenResponse, Error, GuestTokenRequest> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ guestId, password }) => guestTokenApi(guestId, password),
    onSuccess: async (data) => {
      // Clear cache so guest users never see stale data
      queryClient.clear()
      await queryClient.invalidateQueries({ queryKey: ['users', 'self'] })
      log.info('Guest token mutation successful')
    },
    onError: (error) => {
      log.error('Guest token request failed:', error)
    },
  })
}

